<template>
  <f7-page name="ccm-incorrect-study" class="page-bg-render">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        오답 클리닉 학습
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

		<div class="list">
			<ul>
				<li class="item-content item-input">
					<div class="item-inner">
						<div class="item-title item-label">학습 과정</div>
						<div class="item-input-wrap input-dropdown-wrap">
							<select placeholder="학습과정을 선택하세요." v-model="selectedCourse" @change="onCourseChanged">
								<template v-for="(item, i) in courseList">
									<option :key="'i'+i" :value="item">{{getCourseName(i)}}</option>
								</template>
							</select>
						</div>
					</div>
				</li>
				<li class="item-content item-input">
					<div class="item-inner">
						<div class="item-title item-label">대단원</div>
						<div class="item-input-wrap input-dropdown-wrap">
							<select placeholder="대단원을 선택하세요." v-model="selectedBunit" @change="onBunitChanged">
								<template v-for="(item, i) in selectedCourse.bunitList">
									<option :key="'i'+i" :value="item">{{item.BUNIT_NAME}}</option>
								</template>
							</select>
						</div>
					</div>
				</li>
			</ul>
		</div>

		<div class="list">
			<ul>
				<li class="item-content item-inner">
					<div class="item-title" style="width:100%;">
						<div class="item-header padding-bottom-half">
							<span class="vertical-align-middle">대단원 전체 오답 학습</span>
							<i class="bunit-study-tooltip f7-icons vertical-align-middle">question_circle_fill</i>
						</div>
						<div class="row">
							<div class="col">
								<button class="button button-fill" @click="startStudyBunitIncorrect()">오답문제 다시풀기</button>
							</div>
							<div class="col">
								<button class="button button-fill" @click="startStudyBunitSimilar()">오답유사 문제풀기</button>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>

		<div class="list">
			<ul>
				<template v-for="(iItem, i) in sunitList">
					<li :key="'ia'+i" style="background-color:#f0f0f0;">
						<div class="item-content item-inner">
							<div class="item-title">
								<div class="item-header">{{iItem.MUNIT_NAME}}</div>
								<i class="sunit-study-tooltip f7-icons vertical-align-middle">question_circle_fill</i>
								<a href="#" class="margin-right vertical-align-middle" :data-index="i" @click="startStudySunitIncorrect(i)">오답</a>
								<a href="#" class="margin-right vertical-align-middle" :data-index="i" @click="startStudySunitSimilar(i)">유사</a>
								<span class="vertical-align-middle">{{iItem.SUNIT_NAME}}</span>
							</div>
						</div>
					</li>
					<li :key="'ib'+i">
						<div class="item-content item-inner">
							<div class="item-title">
								<div style="display:flex; flex-direction:row;">
									<div style="white-space:normal; padding:2px;">
										<template v-if="iItem.incorrectList.length > 0">
											<a href="#" v-for="(jItem,j) in iItem.incorrectList" :key="'j'+j" :data-index="i" @click="showLinkExam(i, j)" :set="lastItem = jItem">
												<img class="vertical-align-middle" :src="'static/clinic/incorrect.png'" style="margin-left:4px"/>	
											</a>
											<span v-if="lastItem.CNT > 20">... 외 {{lastItem.CNT - 20}}개 문항</span>
										</template>
										<template v-else>
											<span>소단원내에 틀린 문제가 없습니다.</span>
										</template>
									</div>
								</div>
							</div>
						</div>
					</li>
				</template>
			</ul>
		</div>
   
  </f7-page>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js'
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

// item.GRADE_ID+'.'+item.REVISE_ID+'.'+item.SEMESTER_ID

const PAT_CONQUER_STUDY_PAT_CNT = 3;

export default {
	components: {

	},
  data() {
    return {
			selectedCourse: {},
			selectedBunit: {},
			courseList: [],
			sunitList: []
    }
  },
  mounted() {
		var tooltip = this.$f7.tooltip.create({
			targetEl: ".bunit-study-tooltip",
			text: "대단원 학습 : 대단원에서 9문제씩 학습<br/>오답 : 소단원내에 틀린문제를 그대로 다시 풀기<br/>유사 : 틀린문제의 유사문제 풀기",
		});

		this.loadCourseBunitList();
		$(document).on('page:reinit', '.page[data-name="ccm-pat-study"]', this.onPageShow);
  },
  methods: {
		onPageShow() {
			this.loadCourseBunitList();
		},
		getCourseName(itemIndex) {
			var item = this.courseList[itemIndex];

			var courseId = item.GRADE_ID + item.SEMESTER_ID;
			var courseName = CONST.courseMap[courseId].name;
	
			return courseName + "(" + item.REVISE_ID + "개정)";
		},
		onCourseChanged() {
			this.selectedBunit = this.selectedCourse.bunitList[0];
			this.onBunitChanged();
		},
		onBunitChanged() {
			this.loadMunitSunitClinicList();
		},
		getNextBunitLinkExamList() {
			var array = [];

			// sunit의 오답문항을 골고루 선택 함

			var MAX_EXAM_CNT = 9;

			for (var i=0; i<MAX_EXAM_CNT; i++) {
				for (var j=0; j<this.sunitList.length; j++) {
					var sunitItem = this.sunitList[j];

					if (i < sunitItem.incorrectList.length) {
						var incorrectItem = sunitItem.incorrectList[i];

						array.push(incorrectItem);

						if (array.length >= MAX_EXAM_CNT) {
							return array;
						}
					}
				}
			}

			return array;
		},
		getNextSunitLinkExamList(sunitIndex) {
			var array = [];

			// sunit내의 오답문항을 선택 함

			var MAX_EXAM_CNT = 9;

			var sunitItem = this.sunitList[sunitIndex]; 

			for (var i=0; i<sunitItem.incorrectList.length; i++) {
				var incorrectItem = sunitItem.incorrectList[i];

				array.push(incorrectItem);

				if (array.length >= MAX_EXAM_CNT) {
					return array;
				}
			}

			return array;
		},
		startStudyBunitIncorrect() {
			var array = this.getNextBunitLinkExamList();

			var url = PAGES.SUB_CCM_CLINIC_APPLY;
			var param = {
				clinicMode: "incorrect",
				linkExamArray: array
			}
			PAGES.popPage(url, param);
		},
		startStudyBunitSimilar() {
			var array = this.getNextBunitLinkExamList();

			var url = PAGES.SUB_CCM_CLINIC_APPLY;
			var param = {
				clinicMode: "similar",
				linkExamArray: array
			}
			PAGES.popPage(url, param);
		},
		startStudySunitIncorrect(sunitIndex) {
			var array = this.getNextSunitLinkExamList(sunitIndex);

			var url = PAGES.SUB_CCM_CLINIC_APPLY;
			var param = {
				clinicMode: "incorrect",
				linkExamArray: array
			}
			PAGES.popPage(url, param);
		},
		startStudySunitSimilar(sunitIndex) {
			var array = this.getNextSunitLinkExamList(sunitIndex);

			var url = PAGES.SUB_CCM_CLINIC_APPLY;
			var param = {
				clinicMode: "similar",
				linkExamArray: array
			}
			PAGES.popPage(url, param);
		},
		showLinkExam(sunitIndex, linkExamIndex) {

		},
    loadCourseBunitList() {
			var _this = this;
			
			let param = {
			};

			API.ajaxRequest({
				url: API.getCourseBunitListUrl(),
				data: param
			}).then(function (data) {
				_this.courseList = data.courseList;

				if (_this.courseList.length > 0) {

					var found = false;

					for (var i=0; i<_this.courseList.length; i++) {
						var courseItem = _this.courseList[i];
						if (courseItem.lastItem) {
							_this.selectedCourse = courseItem;

							for (var j=0; j<courseItem.bunitList.length; j++) {
								var bunitItem = courseItem.bunitList[j];

								if (bunitItem.lastItem) {
									_this.selectedBunit = bunitItem;
									found = true;
									break;
								}
							}

							break;
						}
					}

					if (!found) {
						_this.selectedCourse = _this.courseList[0];
						_this.selectedBunit = _this.selectedCourse.bunitList[0];
					}
					
					_this.onBunitChanged();
				}
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		},
		loadMunitSunitClinicList() {
			var _this = this;

			let param = {
				pBunitKey: _this.selectedBunit.BUNIT_KEY
			};

			API.ajaxRequest({
				url: API.getMunitSunitClinicListUrl(),
				data: param
			}).then(function (data) {
				_this.sunitList = data.sunitList;

				_this.$utils.nextTick(function() {
					var tooltip = _this.$f7.tooltip.create({
						targetEl: ".sunit-study-tooltip",
						trigger: "click",
						text: "소단원 학습 : 소단원에서 9문제씩 학습<br/>오답 : 소단원내에 틀린문제를 그대로 다시 풀기<br/>유사 : 틀린문제의 유사문제 풀기",
					});
				});

			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		}
  }
}

</script>